// extracted by mini-css-extract-plugin
export default {"container":"nD-z","dimension":"oD-z","dimensionLabels":"pD-z"};